import { render, staticRenderFns } from "./CalendarClockIcon.vue?vue&type=template&id=53d65ba1"
import script from "./CalendarClockIcon.vue?vue&type=script&lang=js"
export * from "./CalendarClockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports